<sew-ad-teaser
    headline="{{ 'TEASER.REQUEST_REPLACEMENT_PRODUCT.HEADLINE' | translate }}"
    text="{{ 'TEASER.REQUEST_REPLACEMENT_PRODUCT.TEXT' | translate }}"
>
    <sew-picture
        slot="picture"
        [src]="'assets/pictures/gear_motor_austausch_184x104.jpg'"
        [alt]="'TEASER.REQUEST_REPLACEMENT_PRODUCT.HEADLINE' | translate"
        [imgTitle]="'TEASER.REQUEST_REPLACEMENT_PRODUCT.HEADLINE' | translate"
    ></sew-picture>
    <sew-link slot="link">
        <a
            type="link"
            target="_blank"
            rel="noopener noreferrer"
            [href]="requestReplacementProductUrl | async"
            oscTrackClick="furtherLinks.thirdPartyDrive"
        >
            {{ 'TEASER.REQUEST_REPLACEMENT_PRODUCT.LINK_TEXT' | translate }}
        </a>
    </sew-link>
</sew-ad-teaser>
